// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2ZXZz","title":"AfterFrontImage_title__ppZhe"};